import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow, MaskLines } from "./Reveal";

export const Dawkins = () => (
  <section id="wonder" data-testid="dawkins-section" className="px-5 sm:px-10 lg:px-16 py-24 sm:py-36 border-t border-white/10">
    <Eyebrow className="mb-5">// Appetite for wonder</Eyebrow>
    <h2 className="font-display font-bold uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.9] mb-14">
      <MaskLines lines={["Richard Dawkins -", <span className="text-lime">Appetite for wonder</span>]} />
    </h2>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
      <Reveal className="lg:col-span-5">
        <div data-testid="dawkins-video-embed" className="relative rounded-[2rem] overflow-hidden border border-white/10 bg-panel aspect-[9/10] shadow-[0_40px_100px_-40px_rgba(200,244,90,0.35)]">
          <iframe
            className="absolute inset-0 w-full h-full"
            src="https://www.youtube.com/embed/ZjYPPjoxuhU"
            title="RICHARD DAWKINS - Appetite for Wonder"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-7">
        <blockquote data-testid="dawkins-quote" className="relative">
          <span className="absolute -top-16 -left-2 font-serif text-[10rem] leading-none text-lime/25 select-none" aria-hidden="true">“</span>
          <p className="relative font-serif text-2xl sm:text-3xl lg:text-[2.4rem] leading-[1.25] text-zinc-100">
            “The feeling of awed wonder that science can give us is one of the highest experiences of which the human psyche is capable. It is a deep aesthetic passion to rank with the finest that music and poetry can deliver. It is truly one of the things that make life worth living and it does so, if anything, more effectively if it convinces us that the time we have for living is quite finite.”
          </p>
          <footer className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
            <span className="font-mono text-sm text-zinc-300">― <span className="text-white font-bold">Richard Dawkins,</span></span>
            <a
              data-testid="goodreads-link-button"
              href="https://www.goodreads.com/work/quotes/3323916"
              target="_blank"
              rel="noreferrer"
              className="group inline-flex items-center gap-3 rounded-full border border-lime/50 px-5 py-2.5 text-sm text-lime hover:bg-lime hover:text-ink transition-colors duration-300"
            >
              Unweaving the Rainbow: Science, Delusion and the Appetite for Wonder
              <ArrowUpRight className="w-4 h-4 shrink-0 transition-transform duration-300 group-hover:rotate-45" />
            </a>
          </footer>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
